import { Button, Input } from "antd";
import React, { useState } from "react";
import { MyModal } from "../../../../components/styled-components";

interface NoItemModalProps {
  visible: boolean;
  onConfirm: (userID: string) => void;
}

const NoItemModal: React.FC<NoItemModalProps> = ({ visible, onConfirm }) => {
  const [userID, setUserId] = useState("");
  const handleReset = () => {
    setUserId("");
  };

  const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const upperCaseInput = e.target.value.toUpperCase();
    if (upperCaseInput.length <= 7) {
      setUserId(upperCaseInput);
    }
  };

  const handleConfirm = () => {
    onConfirm(userID);
  };

  return (
    <MyModal
      title="กรุณาใส่รหัสเพื่อปลดล็อค Batch"
      visible={visible}
      footer={[
        <Button key="reset" onClick={handleReset}>
          รีเซ็ต
        </Button>,
        <Button key="ยืนยัน" type="primary" onClick={handleConfirm}>
          ยืนยัน
        </Button>,
      ]}
    >
      <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
        <Input.Password
          style={{ width: "60vw", marginRight: "8px", textAlign: "center" }}
          maxLength={7}
          onChange={handleUserIdChange}
          value={userID}
          placeholder="User ID (Admin or Zone)"
        />
      </div>
    </MyModal>
  );
};

export default NoItemModal;
